<template>
  <div class="disponibilidad" style="background-color:#ffffff; border-radius: 20px;">

    <vue-element-loading :active="cargando" spinner="bar-fade-scale" color="#064dc3" size="120" :is-full-screen="true" text="Cargando..."/>
    <div class="form-row">
      <h1 class="col-9">Unidades en Taller</h1>
      <div class="col-2"></div>
      <router-link to="/home">
        <b-button variant="outline-success" style="margin: 10px">
          <div class="h6 mb-1">
            <b-icon-arrow-left-square></b-icon-arrow-left-square>
          </div>
          <div style="font-size: 12px;">
            Inicio
          </div>
        </b-button>
      </router-link>
    </div>
    
    <button class="btn btn-sm btn-primary mt-3" @click="generarReporte()">Generar reporte</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportTableToExcel('tableID')">Exportar Excel</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportTableToCSV('tableID')">Exportar CSV</button>
    <div class="table-responsive mt-4">
      <table id ="tableID" name="tableID" class="table table-bordered table-hover text-center">
        <thead style="background-color: #05123C;">
          <tr class="text-white">
            <th>Unidad</th>
            <th>Grupo</th>
            <th>Sitio</th>
            <th>Fecha</th>
            
            <!--<th>Sitio</th>-->
            <!--<th>Odómetro final</th>
            <th>Velocidad promedio</th>
            <th>Velocidad máxima</th>
            <th>Horas motor</th> -->
            <!-- <th>Combustible utilizado</th> -->
          </tr>
        </thead>
        <tbody>
          <tr   v-for="item of formatearDatos" >
            
            <td>{{ item.unidad }}</td>
            <td>{{ item.nombregrupo}}</td>
             <td>{{ item.sitio }}</td>
            <td>{{ item.fecha}}</td>
           
            <!--<td></td>-->
            <!--<td>{{ item.endOdometer }} km</td>
            <td>{{ item.averageSpeed }} km/h</td>
            <td>{{ item.maxSpeed }} km/h</td>-->
            <!-- <td>{{ item.engineHours }}</td> -->
            <!-- <td>{{ item.spentFuel }}</td> -->
          </tr >
          
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>
import moment from 'moment';

import { mapState, mapMutations, mapActions } from "vuex";
require('moment/locale/es');


//import {mostrarMensajeErrorCatch, mostrarMensajeInformativo, mostrarMensajeExitoso, mostrarMensajeError} from '../../mixins/mensajes';

export default {
  data() {
    return {
            dispositivosObtenidos: [],
      arrayAll: [],
      dispositivosSeleccionados: [],
      gruposObtenidos: [],
      gruposSeleccionados: [],
      geocercasObtenidas: [],
      geocercasSeleccionadas: [],
      geocercasSeleccionadas2: [],
      fechaInicio: '03/03/2022',
      horaInicio: '00:00',
      fechaFin: '03/03/2022',
      horaFin: '00:00',
      datosReporte: [],
      datosReporte2: [],
      fecha3dias: moment().subtract(2, 'days').format()
       
      
    }
  },
 

  computed: {
    ...mapState({
      catUnidades: state => state.catalogos.catUnidades,
      catGeocercas: state => state.catalogos.catGeocercas
    
    }),

    ...mapState(["cargando"]),

    formatearIds() {
      let data = '';
      var index = 0;
      for (let item of this.dispositivosSeleccionados) {
        (index == 0) ? data += 'deviceId=' + item.id : data += '&deviceId=' + item.id;
        index++;
      }
      return data;
    },
    

    formatearIdGrupo() {
      let data = '';
      var index = 0;
      for (let item of this.gruposSeleccionados) {
        (index == 0) ? data += 'groupId=' + item.id : data += '&groupId=' + item.id;
        index++;
      }
      return data;
    },
    formatearIdGeocerca() {
       var index = 0;
      for (let item of this.geocercasSeleccionadas) {
        this.geocercasSeleccionadas2.push(item.id);
        index++;
      }
      return this.geocercasSeleccionadas2;
    },

    formatearDatos() {
     
      var index = 0;
      for (let item of this.datosReporte) {
   
        index++;
      }
      
      return this.datosReporte;
    },
  
  formatearDatos2() {
      var index = 0;
      for (let item of this.datosReporte2) {
      
        index++;
      }
      return this.datosReporte2;
    }
  },

 
    
                  
       
 

 

  methods: {
    ...mapActions("catalogos", ["obtenerUnidades"],["obtenerGeocercas"]),
    ...mapMutations(["setearCargando"]),

   /* obtenerSesion() {
      let params = new URLSearchParams();
      params.append("email", "desarrollo.gps@busmen.com");
      params.append("password", "12345");
      let headers = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };

      axios.post(`${url}session`, params, JSON.parse(localStorage.user))
        .then(response => {
          console.log("Sesion");
        })
        .catch(error => {
          console.log("No sesion");
        });
    },*/

    

    reporteDispositivos(){
      axios.get(`${url3}unidades_taller`, { mode: 'cors' }, JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte =  response.data.datos;
          
       //  this.setearCargando(false); 
        })
        .catch(error => {
          alert('Ha ocurrido un error');
         
        });
    },
     reporteGeocercas(){
      axios.get(`${url}geofences`, JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte2 = response.data;
          this.setearCargando(false);
          
        })
        .catch(error => {
          alert('Ha ocurrido un error');
        
        });
    },

     generarReporte() {

        
         this.setearCargando(true);
        this.reporteDispositivos();
        this.reporteGeocercas();
        this.selectGeocercasAll();
        
       
    
    }, 

    
  
     selectGeocercasAll() {
      this.geocercasSeleccionadas = [];
      for (let item of this.geocercasObtenidas) {
        
          this.geocercasSeleccionadas.push(item);
          
      }
    },

    removeAll() {
      this.dispositivosSeleccionados = [];
      this.dispositivosSeleccionados2 = [];
      this.gruposSeleccionados = [];
      this.gruposSeleccionados2 = []; 
      this.dispositivosSeleccionados = [];
      this.geocercasSeleccionadas = [];         
      this.geocercasSeleccionadas2 = []; 
    },
    removeAllGrupos() {
      this.gruposSeleccionados = [];
    },

    
    obtenerDispositivos() {
      this.setearCargando(true);
      axios.get(`${url}devices`, JSON.parse(localStorage.user))
        .then(response => {
          this.dispositivosObtenidos = response.data;
         this.setearCargando(false); 
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },
    exportTableToExcel(tableID, filename = ''){
    var downloadLink;
    var dataType =  'application/vnd.ms-excel' +  ';charset=utf-8';
    var tableSelect = document.getElementById("tableID");
    var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
   
    // Specify file name
    filename = filename?filename+'.xls':'UnidadEnTaller.xls';
   
    // Create download link element
    downloadLink = document.createElement("a");
   
    document.body.appendChild(downloadLink);
   
    if(navigator.msSaveOrOpenBlob){
        var blob = new Blob(['ufeff', tableHTML], {
            type: dataType
        });
        navigator.msSaveOrOpenBlob( blob, filename);
    }else{
        // Create a link to the file
        downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
   
        // Setting the file name
        downloadLink.download = filename;
       
        //triggering the function
        downloadLink.click();
    }
 },
 
exportTableToCSV(tableID, filename = '') {
    var csv = [];
    var rows = document.querySelectorAll('#' + tableID + ' tr');

    // Convert each row of the table into a CSV row
    for (var i = 0; i < rows.length; i++) {
        var row = [], cols = rows[i].querySelectorAll('td, th');

        for (var j = 0; j < cols.length; j++) {
            // Convert the date format if the cell contains a valid date in the 'YYYY-MM-DD HH:mm:ss' format
            var cellData = cols[j].innerText;
            var dateRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
            if (dateRegex.test(cellData)) {
                var dateParts = cellData.split(' ');
                var date = dateParts[0].split('-').reverse().join('/');
                cellData = date + ' ' + dateParts[1];
            }
            row.push(cellData);
        }

        csv.push(row.join(','));
    }

    // Convert the CSV data to a Blob
    var csvData = csv.join('\n');
    var blob = new Blob(['\ufeff', csvData], { type: 'text/csv;charset=utf-8;' });

    // Create download link element
    var downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.setAttribute('download', filename ? filename + '.csv' : 'UnidadEnTaller.csv');

    // Append the link to the body and click it to trigger the download
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
},

    obtenerGrupos() {
      this.setearCargando(true);
      axios.get(`${url}groups`, JSON.parse(localStorage.user))
        .then(response => {
          this.gruposObtenidos = response.data;
             this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
    
     obtenerGeocercas() {
      this.setearCargando(true);
      axios.get(`${url}geofences`, JSON.parse(localStorage.user))
        .then(response => {
          this.geocercasObtenidas = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
  },

  created() {
      
    this.obtenerDispositivos();
    this.obtenerGrupos();
    this.obtenerGeocercas();
   
    // this.obtenerUnidades();
    // this.obtenerSesion();
  },

 
  
  
  
  mounted() {
    // this.obtenerKilometraje();
    if (sessionStorage.aleatorio != 1379248){
    this.$router.push({name: "/" });
  }
  }
}




</script>
<style>
  .disponibilidad{
    margin: 50px;
    margin-bottom:1%;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-top:15px;
  }
</style>